import CallIcon from "../assets/icons/call-icon"
import ChevronRight from "../assets/icons/chevron-right"
import RoundedCheckWithBackground from "../assets/icons/rounded-check-with-background"
import { finishWebView } from "../shared/app-interface"
import { NAVIGATE, NAVIGATE_TYPE } from "../shared/constants/navigation-types"
import { useAssessmentStore } from "../shared/store"
import BottomSheet from "./bottom-sheet"

interface AudioAssessmentSuccessfulProps {
    open: boolean
}

const AssessmentSuccess = ({ open }: AudioAssessmentSuccessfulProps) => {
    const { screenDetails, assesmentQuestions, jobDetails } = useAssessmentStore(
        (state) => state
    )
    const nagivationType = screenDetails?.cta?.type
    const showCall =
        nagivationType === NAVIGATE.DIRECT_CALL || nagivationType === NAVIGATE.MASKED_CALL
    const isVasFlow = assesmentQuestions?.mandatory
    const hrNumber = jobDetails?.job_info?.interview_detail?.hr_number
    const isEnglishAvailable = jobDetails?.job_assessment_info?.english_required
    const jobTitle = jobDetails?.job_info?.title
    const jobId = jobDetails?.job_info?.id
    const handleNavigate = () => {
        const data = {
            intent: "navigate",
            flowType: isVasFlow ? "vas" : "enrichment",
            navigateTo: NAVIGATE_TYPE[nagivationType],
            jobId: jobId,
            hrNumber: hrNumber,
            isEnglishAvailable: isEnglishAvailable,
            jobTitle: jobTitle,
        }
        finishWebView(JSON.stringify(data))
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const toggleSuccessSheet = () => {}
    const handleTrack = () => {
        const data = {
            intent: "navigate",
            flowType: isVasFlow ? "vas" : "enrichment",
            navigateTo: "track",
            jobId: jobId,
            hrNumber: hrNumber,
            isEnglishAvailable: isEnglishAvailable,
            jobTitle: jobTitle,
        }
        finishWebView(JSON.stringify(data))
    }
    return (
        <BottomSheet
            sheetId="access-sheet"
            onClose={toggleSuccessSheet}
            open={open}
            anchor="bottom"
            PaperProps={{
                sx: {
                    borderRadius: "16px 16px 0 0",
                },
            }}
        >
            <div className="flex flex-col items-center justify-end w-[100%] mt-[188px]">
                {/* Content */}
                <div className="flex flex-col items-center justify-center p-4">
                    <div className="flex flex-col items-center my-8">
                        <RoundedCheckWithBackground />
                    </div>
                    <div>
                        <p className="text-base font-semibold mb text-center text-[#190A28] leading-6">
                            {screenDetails?.title}
                        </p>
                        {screenDetails?.sub_title && (
                            <div className="mt-8 mb-1 px-4 text-base text-onSurface-primary font-semibold text-center">
                                {screenDetails.sub_title}
                            </div>
                        )}
                        <p className="text-sm text-center text-[#8C8594] leading-5">
                            {screenDetails?.body}
                        </p>
                    </div>
                    <div className="w-[100%] flex justify-center mt-[72px]">
                        <p className="text-sm">{screenDetails?.lower_text}</p>
                        <div
                            className="text-[#2BB792] flex justify-center items-center ml-1"
                            onClick={handleTrack}
                        >
                            <p className="text-sm">Track</p>
                            <ChevronRight />
                        </div>
                    </div>
                </div>
                {/* Button */}
                <div className="w-[100%] mt-4 border-t border-solid border-[#e0e0e0] p-4">
                    <button
                        className="w-[100%] p-4 rounded-lg flex justify-center items-center bg-green "
                        onClick={handleNavigate}
                    >
                        {showCall && <CallIcon />}
                        <p className="ml-2 font-semibold text-base text-white">
                            {screenDetails?.cta?.text}
                        </p>
                    </button>
                </div>
            </div>
        </BottomSheet>
    )
}
export default AssessmentSuccess
